export default {
  inserted() {
    document.documentElement.style.setProperty(`transition`, `filter 1s`)
  },
  update(el, { value, oldValue }) {
    if (value === oldValue) return false

    if (value /* Boolean */) {
      document.documentElement.style.setProperty(
        `filter`,
        `contrast(1.13) brightness(1.7)`
      )
    } else {
      document.documentElement.style.removeProperty(`filter`)
    }
  },
}
